/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetupParameterKind } from '../../models/setup-parameter-kind';

export interface GetSetupParameterKinds$Params {
  productionOrderId: number;
}

export function getSetupParameterKinds(http: HttpClient, rootUrl: string, params: GetSetupParameterKinds$Params, context?: HttpContext): Observable<StrictHttpResponse<SetupParameterKind>> {
  const rb = new RequestBuilder(rootUrl, getSetupParameterKinds.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SetupParameterKind>;
    })
  );
}

getSetupParameterKinds.PATH = '/api/v1/SetupParameter/GetSetupParameterKinds/{productionOrderId}';
